define('models/activities/posts/post_collection',["backbone",
        "models/activities/posts/postitem"
], function (Backbone, PostItem) {
    var Conversations = Backbone.Collection.extend({
        url: function () {
            var url = this.instanceURL ? this.instanceURL : pf.accountsURL + "/0/Posts";
            var postGUIDstr = this.lastPostGUID ? "&PostGUID=" + this.lastPostGUID : "";
                if (this.panel) {
                    url += "?Panel=true";
                }
                else if (this.count && !this.currentPage) {
                    url += "?Count=" + this.count + postGUIDstr;
                }
                else if (this.currentPage) {
                    url += "?PageNumber=" + this.currentPage + postGUIDstr;
                }
                if (this.postCategoryID && this.postCategoryID != '0')
                {
                    if (url.indexOf("?") >= 0)
                        url += "&postCategoryID=" + this.postCategoryID;
                    else
                        url += "?postCategoryID=" + this.postCategoryID;

                }
                return url;
        },
        model: PostItem,
        initialize: function (attributes, options) {
            options || (options = {});

            this.instanceURL = options.instanceURL;
            this.panel = options.panel;
            this.count = options.count;
            if (options.lastPostGUID)
                this.lastPostGUID = options.lastPostGUID;
            else
                this.lastPostGUID = null;
            this.currentPage = options.PageNumber;
            if (options.pageSize > 0)
                this.pageSize = parseInt(options.pageSize);
            else
                this.pageSize = 10;
            this.postCategoryID = options.postCategoryID;
        },
        parse: function (resp, options) {
            this.currentPage = resp.currentPage;
            this.totalRecords = resp.total_count;
            this.totalPages = this.totalRecords / this.pageSize;
            if (resp.items)
                return resp.items;
            else
                return resp;
        }
    });
    return Conversations;
});
